export const FileActions = {
    INIT_READ_STATUS: "INIT_READ_STATUS",
    UPDATE_READ_STATUS: "UPDATE_READ_STATUS",
    UPDATE_SELECTED_FILE: "UPDATE_SELECTED_FILE",
}